import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export default function Relance() {

     const [mailrelance, setMailrelance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [editingMail, setEditingMail] = useState(null);
  const [isSourceMode, setIsSourceMode] = useState(false);
  const [variables, setVariables] = useState(['nom', 'numero_devis', 'montant_total', 'lien_devis']);
  
  // États pour l'édition
  const [editData, setEditData] = useState({
    id: '',
    nom: '',
    sujet: '',
    contenu: '',
    expediteur_nom: '',
    expediteur_email: '',
    mode_envoi: '',
    actif: 1
  });

  const editorRef = useRef(null);
  const sourceRef = useRef(null);

  useEffect(() => {
    fetchMails();
  }, []);

  const fetchMails = () => {
    setLoading(true);
    axios
      .get(`${apiUrl}/IHM/api/mails/mails.php?relance`)
      .then((response) => {
        setMailrelance(response.data);
      })
      .catch((error) => {
        console.error("Erreur:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleEdit = (rowData) => {
    setEditingMail(rowData);
    setEditData({
      id: rowData.id,
      nom: rowData.type_mail || 'devis_stock',
      sujet: rowData.sujet || '',
      contenu: rowData.corps_html || '',
      expediteur_nom: rowData.expediteur_nom || '',
      expediteur_email: rowData.expediteur_email || '',
      mode_envoi: rowData.mode_envoi || '',
      actif: rowData.actif || 1
    });
    setIsSourceMode(false);
    setEditDialogVisible(true);
  };

  const handleSave = async () => {
    try {
      const contenu = isSourceMode 
        ? sourceRef.current?.textContent 
        : editorRef.current?.innerHTML;

      const response = await axios.post(
        `${apiUrl}/IHM/api/mails/mails.php`,
        {
          id: editData.id,
          nom: editData.nom,
          sujet: editData.sujet,
          contenu: contenu,
          expediteur_nom: editData.expediteur_nom,
          expediteur_email: editData.expediteur_email,
          mode_envoi: editData.mode_envoi,
          actif: editData.actif
        }
      );

      if (response.data.success) {
        fetchMails();
        setEditDialogVisible(false);
        showToast("Modèle enregistré avec succès !", "success");
      }
    } catch (error) {
      console.error("Erreur:", error);
      showToast("Erreur lors de l'enregistrement", "error");
    }
  };

  const execCmd = (command) => {
    document.execCommand(command, false, null);
    editorRef.current?.focus();
  };

  const insertVariable = () => {
    const varList = variables.map(v => `{${v}}`).join(', ');
    const selected = prompt(`Variables disponibles: ${varList}`, `{${variables[0]}}`);
    if (selected) {
      document.execCommand('insertHTML', false, selected);
      editorRef.current?.focus();
    }
  };

  const toggleSource = () => {
    const newSourceMode = !isSourceMode;
    setIsSourceMode(newSourceMode);
    
    if (newSourceMode) {
      // Passer en mode source
      const content = editorRef.current?.innerHTML || '';
      if (sourceRef.current) {
        sourceRef.current.textContent = content;
      }
    } else {
      // Retour en mode visuel
      const sourceContent = sourceRef.current?.textContent || '';
      if (editorRef.current) {
        editorRef.current.innerHTML = sourceContent;
      }
    }
  };

  const previewEmail = () => {
    const content = isSourceMode 
      ? sourceRef.current?.textContent 
      : editorRef.current?.innerHTML;
    
    if (!content) return;

    let previewHtml = content;
    variables.forEach(varName => {
      const exampleValue = varName.charAt(0).toUpperCase() + varName.slice(1);
      previewHtml = previewHtml.replace(
        new RegExp(`\\{${varName}\\}`, 'g'), 
        exampleValue
      );
    });

    // Ouvrir dans une nouvelle fenêtre pour aperçu
    const win = window.open('', '_blank', 'width=800,height=600');
    if (win) {
      win.document.write(`
        <html>
          <head><title>Aperçu de l'email</title></head>
          <body style="padding: 20px; background: #f5f5f5;">
            <div style="max-width: 600px; margin: 0 auto; background: white; padding: 20px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
              ${previewHtml}
            </div>
          </body>
        </html>
      `);
      win.document.close();
    }
  };


 const showToast = (message, type = 'success') => {
    alert(message);
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
        <Button
          icon="pi pi-pencil"
          severity="info"
          text
          raised
          size="small"
          tooltip="Modifier le mail"
          tooltipOptions={{ position: "top", style: { fontSize: "0.7rem" } }}
          onClick={() => handleEdit(rowData)}
        />
      </div>
    );
  };



 
    return (
        <>
          <DataTable
            value={mailrelance}
            paginator
            rows={25}
            size="small"
            tableStyle={{ minWidth: "50rem" }}
            scrollable
            scrollDirection="horizontal"
            paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
            paginatorRight={
              <span style={{ margin: "10px", fontWeight: "bold" }}>
                Résultats : {mailrelance.length}
              </span>
            }
            loading={loading}
            loadingIcon="pi pi-spin pi-spinner"
            emptyMessage={
              loading
                ? "Chargement des fiches en cours..."
                : "Aucune fiche pour le moment"
            }
          >
            <Column field="id" header="ID" style={{ width: "80px" }} />
            <Column field="mode_envoi" header="Mode" style={{ width: "120px" }} />
            <Column field="sujet" header="Sujet" style={{ minWidth: "250px" }} />
    
            <Column
              header="Actions"
              style={{ textAlign: "center", width: "100px" }}
              body={actionBodyTemplate}
            />
          </DataTable>
    
          <Dialog
            header="Éditer le modèle d'email"
            visible={editDialogVisible}
            style={{ width: "90vw", maxWidth: "1000px" }}
            modal
            onHide={() => setEditDialogVisible(false)}
            footer={
              <div className="w-full">
               
                <Button
                  className="w-full"
                  style={{
                    background: "#1d4ed8",
                    border: "1px solid #1d4ed8",
                    padding: "0.75rem",
                    borderRadius: "6px",
                    fontSize: "14px",
                    fontWeight: 500,
                    justifyContent: "center",
                    gap: "8px",
                    color: "#fdfeff",
                  }}
                  label="Enregistrer"
                  icon="pi pi-check"
                  onClick={handleSave}
                  autoFocus
                />
              </div>
            }
          >
            <div style={{ padding: "20px" }}>
              {/* Informations générales */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "15px",
                  marginBottom: "20px",
                }}
              >
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Nom *
                  </label>
                  <InputText
                    value={editData.nom}
                    onChange={(e) =>
                      setEditData({ ...editData, nom: e.target.value })
                    }
                    style={{ width: "100%" }}
                  />
                </div>
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Sujet *
                  </label>
                  <InputText
                    value={editData.sujet}
                    onChange={(e) =>
                      setEditData({ ...editData, sujet: e.target.value })
                    }
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
    
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "15px",
                  marginBottom: "20px",
                }}
              >
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Email expéditeur
                  </label>
                  <InputText
                    value={editData.expediteur_email}
                    onChange={(e) =>
                      setEditData({ ...editData, expediteur_email: e.target.value })
                    }
                    style={{ width: "100%" }}
                  />
                </div>
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Nom expéditeur
                  </label>
                  <InputText
                    value={editData.expediteur_nom}
                    onChange={(e) =>
                      setEditData({ ...editData, expediteur_nom: e.target.value })
                    }
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
    
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr 1fr",
                  gap: "15px",
                  marginBottom: "20px",
                }}
              >
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Mode d'envoi
                  </label>
                  <select
                    value={editData.mode_envoi}
                    onChange={(e) =>
                      setEditData({ ...editData, mode_envoi: e.target.value })
                    }
                    style={{
                      width: "100%",
                      padding: "8px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                    }}
                  >
                    <option value="otedalon">Otedalon</option>
                    <option value="stockage_reunion">Stockage Réunion</option>
                    <option value="zotdevis">ZotDevis</option>
                  </select>
                </div>
                <div>
                  <label
                    style={{
                      display: "block",
                      marginBottom: "5px",
                      fontWeight: "bold",
                      fontSize: "14px",
                    }}
                  >
                    Actif
                  </label>
                  <select
                    value={editData.actif}
                    onChange={(e) =>
                      setEditData({ ...editData, actif: parseInt(e.target.value) })
                    }
                    style={{
                      width: "100%",
                      padding: "8px",
                      borderRadius: "4px",
                      border: "1px solid #ced4da",
                    }}
                  >
                    <option value={1}>Oui</option>
                    <option value={0}>Non</option>
                  </select>
                </div>
              </div>
    
              {/* Éditeur */}
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "14px",
                  }}
                >
                  Contenu de l'email *
                </label>
    
                {/* Barre d'outils */}
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "4px",
                    padding: "8px",
                    background: "#f8f9fa",
                    border: "1px solid #ced4da",
                    borderRadius: "6px 6px 0 0",
                    borderBottom: "none",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => execCmd("bold")}
                    style={{
                      padding: "6px 10px",
                      borderRadius: "4px",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                    title="Gras"
                  >
                    <b>B</b>
                  </button>
                  <button
                    type="button"
                    onClick={() => execCmd("italic")}
                    style={{
                      padding: "6px 10px",
                      borderRadius: "4px",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                    title="Italique"
                  >
                    <i>I</i>
                  </button>
                  <button
                    type="button"
                    onClick={() => execCmd("underline")}
                    style={{
                      padding: "6px 10px",
                      borderRadius: "4px",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                    title="Souligné"
                  >
                    <u>U</u>
                  </button>
                  <div
                    style={{
                      width: "1px",
                      height: "24px",
                      background: "#ddd",
                      margin: "0 4px",
                    }}
                  ></div>
                  <button
                    type="button"
                    onClick={() => execCmd("insertUnorderedList")}
                    style={{
                      padding: "6px 10px",
                      borderRadius: "4px",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                    title="Liste"
                  >
                    <i className="pi pi-list"></i>
                  </button>
                  <button
                    type="button"
                    onClick={() => execCmd("insertOrderedList")}
                    style={{
                      padding: "6px 10px",
                      borderRadius: "4px",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                    }}
                    title="Liste numérotée"
                  >
                    <i className="pi pi-sort-numeric-down"></i>
                  </button>
                  <div
                    style={{
                      width: "1px",
                      height: "24px",
                      background: "#ddd",
                      margin: "0 4px",
                    }}
                  ></div>
                  {/* <button
                    type="button"
                    onClick={insertVariable}
                    style={{
                      padding: "6px 10px",
                      borderRadius: "4px",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      color: "#3aaa35",
                    }}
                    title="Insérer une variable"
                  >
                    {"{}"}
                  </button> */}
                  <button
                    type="button"
                    onClick={previewEmail}
                    style={{
                      padding: "6px 10px",
                      borderRadius: "4px",
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      color: "#2563eb",
                    }}
                    title="Aperçu"
                  >
                    <i className="pi pi-eye"></i>
                  </button>
                  <button
                    type="button"
                    onClick={toggleSource}
                    style={{
                      padding: "6px 10px",
                      borderRadius: "4px",
                      border: isSourceMode ? "1px solid #3aaa35" : "none",
                      background: isSourceMode ? "#e8f5e9" : "transparent",
                      cursor: "pointer",
                      fontFamily: "monospace",
                      fontSize: "14px",
                    }}
                    title="Code source"
                  >
                    {"</>"}
                  </button>
                </div>
    
                {/* Éditeur visuel */}
                {!isSourceMode && (
                  <div
                    ref={editorRef}
                    contentEditable
                    style={{
                      border: "1px solid #ced4da",
                      borderTop: "none",
                      padding: "16px",
                      minHeight: "300px",
                      background: "white",
                      borderRadius: "0 0 6px 6px",
                      outline: "none",
                      overflowX: "auto",
                    }}
                    dangerouslySetInnerHTML={{ __html: editData.contenu }}
                    onInput={() => {
                      // Mettre à jour le contenu
                    }}
                  />
                )}
    
                {/* Mode source */}
                {isSourceMode && (
                  <div
                    style={{
                      border: "1px solid #ced4da",
                      borderTop: "none",
                      padding: "16px",
                      minHeight: "300px",
                      background: "#1a1a2e",
                      color: "#fff",
                      fontFamily: "monospace",
                      fontSize: "14px",
                      borderRadius: "0 0 6px 6px",
                      overflowX: "auto",
                    }}
                  >
                    <pre
                      ref={sourceRef}
                      style={{
                        margin: 0,
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-all",
                        color: "#fff",
                      }}
                    >
                      {editData.contenu}
                    </pre>
                  </div>
                )}
              </div>
            </div>
          </Dialog>
        </>
      );
 
}
